export default __webpack_public_path__ + "static/media/welcome-screen.8d0ae76c.png";